import React from 'react';
import c from 'classnames';
import './Alert.scss';
import PropTypes from 'prop-types';

const Alert = ({ text, alert }) => {

  return (
    <div
      className={c('Alert', {
        'Alert--success': alert === 'success',
        'Alert--error': alert === 'error',
      })}
    >
      <div className={c('Alert__Icon')}>
        <div className={`icon-before
        ${alert === 'success' ? 'icon-check icon-variant-dark-green' : ''}
        ${alert === 'error' ? 'icon-info icon-variant-dark-red' : ''}
        `} />
      </div>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
};

export default Alert;

Alert.propTypes = {
  text: PropTypes.string.isRequired,
  alert: PropTypes.oneOf(['success', 'error']).isRequired,
};
